import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import LastDayActivity from "./LastDayActivity";

const Dashboard = () => (
    <div className="container-fluid">
        <LastDayActivity/>
    </div>
);

Dashboard.propTypes = {
    auth: PropTypes.object.isRequired
};

const mapStateToProps = state => ({
    auth: state.auth,
    usersLoading: state.users.loading
});

const mapStateToDispatch = dispatch => ({});

export default connect(
    mapStateToProps,
    mapStateToDispatch
)(Dashboard);



// WEBPACK FOOTER //
// ./src/views/pages/dashboard/index.js